import i18n from "i18next";
import { initReactI18next } from "react-i18next";

let i18nConfiguration = {
  "resources": 
  {
    "en": {
      "translations": {
        "Estonian" : "Estonian",
        "English" : "English",
        "Russian" : "Russian",
        "Ukrainian" : "Ukrainian",

        // Countries in phone number list
        "Poland" : "Poland",
        "Estonia" : "Estonia",
        "Latvia" : "Latvia",
        "Lithuania" : "Lithuania",
        "Germany" :"Germany",
        "Ukraine" : "Ukraine",
        "Moldova, Republic of" : "Moldova",
        "Hungary" : "Hungary",
        "Romania": "Romania",
        "Slovakia": "Slovakia",
        "Belarus" : "Belarus",
        "Russia" : "Russia",
        
        "Rate" : "Rate",
        "Yes" : "Yes",
        "No" : "No",
        "Close": "Close",
        "Clear": "Clear",
        "Finish" : "Finish",
        "Continue" : "Continue",
        "Open": "Open",
        "Start": "Start",
		    "Next" : "Next",
	      "Previous" : "Previous",
        "Please wait" : "Please wait",
        "Problem" : "Problem",
        "There was an error with your request. Please try again." : "There was an error with your request. Please try again.",
        "An technical error occurred, please try again." : "An technical error occurred, please try again.",
        "The calendar is loading" : "The calendar is loading",
        "Loading" : "Loading",
        "Loading available times" : "Loading available times",
        "Pick a date to see available times" : "Pick a date to see available times",
        "Loading available dates" : "Loading available dates",
        "No available dates were found in the selected month" : "No available dates were found in the selected month",
        "No available dates found" : "No available dates found",

        "Insufficient data for evaluation" : "Insufficient data for evaluation",
        "No deviations detected" : "No deviations detected",
        "Moderate deviations" : "Moderate deviations",
        "Significant deviations" : "Significant deviations",
        "Mental health self-assessment" : "Mental health self-assessment",
        "Summary" : "Summary",
        "Summary of the results" : "Summary of the results",
        
        "Download the self-assessment summary" : "Download the self-assessment summary",
        "Download to .pdf" : "Download to .pdf",
        "Download as .pdf" : "Download as .pdf",
        "Would you like to book a free 30 minutes video consultation?" : "Would you like to book a free 30 minutes video consultation?",
        
        "In our opinion, you do not need a consultation with a mental health professional." : "In our opinion, you do not need a consultation with a mental health professional.",
        "We offer the opportunity for a free video consultation. You will find more information after starting the process of booking" : "We offer the opportunity for a free video consultation. You will find more information after starting the process of booking",
        "We recommend a consultation with a psychiatrist" : "We recommend a consultation with a psychiatrist",
        "We recommend a consultation with a psychologist" : "We recommend a consultation with a psychologist",

        "Book a video-consultation" : "Book a video-consultation",
        "Enter video consultation" : "Enter video consultation",
        "Book a repeat visit" : "Book a repeat visit",
        "Visit the same doctor" : "Visit the same doctor",

        // Need translator
        "At the moment, there are no planned visits and it's not yet possible to book a new visit either." : "At the moment, there are no planned visits and it's not yet possible to book a new visit either.", 
        
        "bookModeDefault" : "Find first time available",
        "bookModeAllDoctors" : "Choose doctor",
        "bookModeRepeatVisit" : "Visit the same doctor",
        "bookModeRepeatVisit2" : "Choose service & doctor",

        "Any employee" : "Any employee",
        "All doctors" : "All doctors",
        
        "Select time" : "Select time",
        "No available times" : "No available times",
        "Confirm time" : "Confirm time",
        "Name" : "Name",
        "Confirm booking" : "Confirm booking",
        "Cancel" : "Cancel",

        "Thank you" : "Thank you",
        "Answers are saved" : "Answers are saved",
        "You have completed the questionnaire." : "You have completed the questionnaire.",
        "If you wish, you can book an appointment for a doctor's consultation." : "If you wish, you can book an appointment for a doctor's consultation.",
        "Your answers have been forwarded to your doctor." : "Your answers have been forwarded to your doctor.",
        
        "Selected date and time" : "Selected date and time",
        "Service" : "Service",
        "Selected date" : "Selected date",
        "Selected time" : "Selected time",
        "_DATE_ at _TIME_" : "_DATE_ at _TIME_",

        "Skip" : "Skip", 
        "Select time for 30 minutes consultation" : "Select time for 30 minutes consultation", 
        "I don't want to proceed" : "I don't want to proceed",
        "How would you rate your experience with our product" : "How would you rate your experience with our product",
        
        "Year" : "Year",
        "Month" : "Month",
        "Day" : "Day",

        "January" : "January",
        "February" : "February",
        "March" : "March",
        "April" : "April",
        "May" : "May",
        "June" : "June",
        "July" : "July",
        "August" : "August",
        "September" : "September",
        "October" : "October",
        "November" : "November",
        "December" : "December",

        "Monday" : "Monday",
        "Tuesday" : "Tuesday",
        "Wednesday" : "Wednesday",
        "Thursday" : "Thursday",
        "Friday" : "Friday",
        "Saturday" : "Saturday",
        "Sunday" : "Sunday",

        "National identification number" : "ID number",
        "Estonian identification number" : "Estonian ID number",
        "Fill only if you have Estonian national identification number" : "Fill only if you have Estonian national identification number",
        "First name" : "First name",
        "Surname" : "Surname",
        "Date of birth" : "Date of birth",
        "Phone (country code)" : "Phone (with country code)",
        "E-mail" : "E-mail",
        "Book an appointment" : "Book an appointment",
        "I agree to the terms of service and data sharing" : "I agree to the terms of service and data sharing",
        "Please fill in the field" : "Please fill in the field",
        "Please fill in the required field" : "please fill in the required field",
        "Please fill in the field correctly" : "Please fill in the field correctly",
        "Confirm" : "Confirm", 

        "Book a video-consultation with a psychiatrist" : "Book a video-consultation with a psychiatrist",
        "Book a video-consultation with a psychologist" : "Book a video-consultation with a psychologist",
        
        "Significant mental health deteriorations are identified." : "Significant mental health deteriorations are identified.",
        "Moderate mental health deteriorations are identified." : "Moderate mental health deteriorations are identified.",
        "We recommend a psychiatric consultation." : "We recommend a psychiatric consultation.",
        "I would like to book a 45-minute video consultation." : "I would like to book a 45-minute video consultation.",
        "I would like to book a 30-minute video consultation." : "I would like to book a 30-minute video consultation.",
        "Please enter your personal ID number to start the booking" : "Please enter your personal ID number to start the booking",
        "We will direct you to book an appointment." : "We will direct you to book an appointment",
        "I'm booking" : "I'm booking",
        "To book" : "To book",

        "Please note!" : "Please note!",
        "I have read and agree to the terms and conditions of the service" : "I have read and agree to the terms and conditions of the service",

        "Select service" : "Select service",
        "Select practicioner" : "Select practicioner",
        
        "Mood" : "Mood",
        "Mood_short" : "M",
        "Anxiety" : "Anxiety",
        "Anxiety_short" : "A",
        "Physical health" : "Physical health",
        "Physical health_short" : "Ph",
        "Sleep" : "Sleep",
        "Sleep_short" : "Sl",
        "Eating" : "Eating",
        "Eating_short" : "E",
        "Cognitive ability" : "Cognitive ability",
        "Cognitive ability_short" : "C",
        "Substance use" : "Substance use",
        "Substance use_short" : "Su",
        "Unusual experiences" : "Unusual experiences",
        "Unusual experiences_short" : "U",
        "Stress" : "Stress",
        "Stress_short" : "St",
        "Obsession-compulsion" : "Obsession-compulsion",
        "Obsession-compulsion_short" : "Oc",
        "Personality" : "Personality",
        "Personality_short" : "P",
        "Safety" : "Safety",
        "Safety_short" : "Sa",
        "Functioning" : "Functioning",
        "Functioning_short" : "F",
        "Social activity" : "Social activity",
        "Social activity_short" : "So",
        "Habits" : "Habits",
        "Habits_short" : "H",
        "Sexual activity" : "Sexual activity",
        "Sexual activity_short" : "Se",
        
        "I agree" : "I agree",
        "Privacy policy" : "Privacy policy",
        "Privacy" : "Privacy",
        "Cookie policy" : "Cookie policy",
        "Terms of use" : "Terms of use",

        "Internet connection lost. " : "Internet connection lost. ",
        "Connection lost with the server. " : "Connection lost with the server. ",
        "Please reload the web page. " : "Please reload the web page. ",
        "Please start over. " : "Please start over. ",

        "We are sorry, but currently the project works for those who are located in Ukraine. " : "We are sorry, but currently the project works for those who are located in Ukraine. ",
        "We are sorry, but currently the project works for those who are located in Ukraine and in Estonia. " : "We are sorry, but currently the project works for those who are located in Ukraine and in Estonia. "
      }
    },
    "et": {
      "translations": {
        "Estonian" : "Eesti keel",
        "English" : "Inglise keel",
        "Russian" : "Vene keel",
        "Ukrainian" : "Ukraina keel",
                
        // Countries in phone number list
        "Poland" : "Poola",
        "Estonia" : "Eesti",
        "Latvia" : "Läti",
        "Lithuania" : "Leedu",
        "Germany" : "Saksamaa",
        "Ukraine" : "Ukraina",
        "Moldova, Republic of" : "Moldova Vabariik",
        "Hungary" : "Ungari",
        "Romania": "Rumeenia",
        "Slovakia": "Slovakkia",
        "Belarus" : "Valgevene",
        "Russia" : "Venemaa",
        

        "Rate" : "Hinda",
        "Yes" : "Jah",
        "No" : "Ei",
        "Close": "Sulge",
        "Clear": "Tühjenda",
        "Finish" : "Lõpeta",
        "Continue" : "Jätka",
        "Open": "Ava",
        "Start": "Alusta",
		    "Next" : "Edasi",
		    "Previous" : "Tagasi",
        "Please wait" : "Palun oota",
        "Problem" : "Probleem",
        "There was an error with your request. Please try again." : "Teie päringus ilmnes viga. Palun proovige uuesti.",
        "An technical error occurred, please try again." : "Ilmnes tehniline viga, proovige uuesti.",
        "The calendar is loading" : "Kalender laeb",
        "Loading" : "Laadimine",
        "Loading available times" : "Saadaolevate aegade laadimine",
        "Pick a date to see available times" : "Vabade aegade vaatamiseks valige kuupäev",
        "Loading available dates" : "Saadaolevate kuupäevade laadimine",
        "No available dates were found in the selected month" : "Valitud kuust ei leitud ühtegi vaba kuupäeva",
        "No available dates found" : "Saadaolevaid kuupäevi ei leitud",

        
        "Insufficient data for evaluation" : "Hindamiseks info puudulik",
        "No deviations detected" : "Kõrvalekaldeid ei tuvasta",
        "Moderate deviations" : "Mõõdukad kõrvelekalded",
        "Significant deviations" : "Märkimisväärsed kõrvalekalded",
        "Mental health self-assessment" : "Vaimse tervise enesehinnang",
        "Summary" : "Kokkuvõte",
        "Summary of the results" : "Tulemuste kokkuvõte",
        
        "Download the self-assessment summary" : "Lae alla enesehindamise kokkuvõte",
        "Download to .pdf" : "Lae alla .pdf",
        "Download as .pdf" : "Laadige alla .pdf-vormingus",
        "Would you like to book a free 30 minutes video consultation?" : "Kas soovite broneerida tasuta 30-minutilise videokonsultatsiooni?",

        "In our opinion, you do not need a consultation with a mental health professional." : "Meie hinnangul sul ei ole vajadust vaimse tervise spetsialisti konsultatsiooni järele.",
        "We offer the opportunity for a free video consultation. You will find more information after starting the process of booking" : "Pakume võimalust tasuta videokonsultatsiooniks. Täpsema info leiad pärast broneeringu alustamist",
        "We recommend a consultation with a psychiatrist" : "Soovitame psühhiaatri konsultatiooni",
        "We recommend a consultation with a psychologist" : "Soovitame psühholoogi konsultatiooni",

        "Book a video-consultation" : "Broneeri videokonsultatsioon",
        "Enter video consultation" : "Sisene videokonsultatsiooni",
        "Book a repeat visit" : "Broneeri korduvkülastus",
        "Visit the same doctor" : "Külasta sama arsti",

        // Need translator
        "At the moment, there are no planned visits and it's not yet possible to book a new visit either." : "Hetkel ei ole kavas ühtegi külastust ja ka uut külastust pole võimalik veel broneerida.", 
        
        "bookModeDefault" : "Esimene vaba aeg",
        "bookModeAllDoctors" : "Vali arst",
        "bookModeRepeatVisit" : "Sama arsti juurde",
        "bookModeRepeatVisit2" : "Vali teenus ja arst",

        "Any employee" : "Ükskõik milline töötaja",
        "All doctors" : "Kõik arstid",

        "Select time" : "Vali aeg",
        "No available times" : "Vabu aegu pole",
        "Confirm time" : "Kinnita valitud aeg",
        "Name" : "Nimi",
        "Confirm booking" : "Kinnita broneering",
        "Cancel" : "Tühista",

        "Thank you" : "Täname",
        "Answers are saved" : "Vastused on salvestatud",
        "You have completed the questionnaire." : "Olete küsimustiku täitnud.",
        "If you wish, you can book an appointment for a doctor's consultation." : "Soovi korral saate broneerida aja arsti konsultatsioonile.",
        "Your answers have been forwarded to your doctor." : "Teie vastused on edastatud Teie raviarstile. ",

        "Selected date and time" : "Valitud kuupäev ja kellaaeg",
        "Service" : "Teenus",
        "Service performer" : "Teenindaja",
        "Selected date" : "Valitud kuupäev",
        "Selected time" : "Valitud kellaaeg",
        "_DATE_ at _TIME_" : "_DATE_ kell _TIME_",

        "Skip" : "Jäta vahele", 
        "Select time for 30 minutes consultation" : "Valige 30-minutilise konsultatsiooni aeg", 
        "I don't want to proceed" : "Ma ei soovi jätkata",
        "How would you rate your experience with our product" : "Kuidas hindaksite oma kogemust meie tootega",
        
        "Year" : "Aasta",
        "Month" : "Kuu",
        "Day" : "Päev",

        "January" : "Jaanuar",
        "February" : "Veebruar",
        "March" : "Märts",
        "April" : "Aprill",
        "May" : "Mai",
        "June" : "Juuni",
        "July" : "Juuli",
        "August" : "August",
        "September" : "September",
        "October" : "Oktoober",
        "November" : "November",
        "December" : "Detsember",

        "Monday" : "Esmaspäev",
        "Tuesday" : "Teisipäev",
        "Wednesday" : "Kolmapäev",
        "Thursday" : "Neljapäev",
        "Friday" : "Reede",
        "Saturday" : "Laupäev",
        "Sunday" : "Pühapäev",
        
        "National identification number" : "Isikukood",
        "Estonian identification number" : "Eesti isikukood",
        "Fill only if you have Estonian national identification number" : "Täitke ainult Eesti riikliku isikukoodi olemasolul",
        "First name" : "Eesnimi",
        "Surname" : "Perekonnanimi",
        "Date of birth" : "Sünnikuupäev",
        "Phone (country code)" : "Telefon (maakoodiga)",
        "E-mail" : "E-mail",
        "Book an appointment" : "Broneerin aja",
        "I agree to the terms of service and data sharing" : "Nõustun teenuse tingimustega ja andmete jagamisega",
        "Please fill in the field" : "Palun täitke väli",
        "Please fill in the required field" : "Palun täitke nõutud väli",
        "Please fill in the field correctly" : "Palun täitke väli korrektselt",
        "Confirm" : "Kinnita", 

        "Book a video-consultation with a psychiatrist" : "Boneeri psühhiaatri videokonsultatsioon",
        "Book a video-consultation with a psychologist" : "Boneeri psühholoogi videokonsultatsioon",
        
        "Significant mental health deteriorations are identified." : "Tuvastasime olulised vaimse tervise kõrvalekalded.",
        "Moderate mental health deteriorations are identified." : "Tuvastasime mõõdukad vaimse tervise kõrvalekalded.",
        "We recommend a psychiatric consultation." : "Soovitame psühhiaatri konsultatsiooni.",
        "I would like to book a 45-minute video consultation." : "Soovin broneerida 45 minutilise video konsultatsiooni.",
        "I would like to book a 30-minute video consultation." : "Soovin broneerida 30 minutilise video konsultatsiooni.",
        "Please enter your personal ID number to start the booking" : "Broneerimise alustamiseks palun sisestage oma isikukood",
        "We will direct you to book an appointment." : "Suuname teid aega broneerima",
        "I'm booking" : "Broneerin",
        "To book" : "Broneerima",

        "Please note!" : "Palun pange tähele!",
        "I have read and agree to the terms and conditions of the service" : "Olen lugenud ja nõustun teenuse tingimustega",
        
        "Select service" : "Vali teenus",
        "Select practicioner" : "Vali arst",

        "Mood" : "Meeleolu",
        "Mood_short" : "Me",
        "Anxiety" : "Ärevus",
        "Anxiety_short" : "Ä",
        "Physical health" : "Kehaline tervis",
        "Physical health_short" : "K",
        "Sleep" : "Uni",
        "Sleep_short" : "U",
        "Eating" : "Söömine",
        "Eating_short" : "Sö",
        "Cognitive ability" : "Kognitiivne võime",
        "Cognitive ability_short" : "K",
        "Substance use" : "Psühhoaktiivsete ainete tarvitamine",
        "Substance use_short" : "A",
        "Unusual experiences" : "Ebatavalised kogemused",
        "Unusual experiences_short" : "Eb",
        "Stress" : "Stress",
        "Stress_short" : "St",
        "Obsession-compulsion" : "Sundseisund",
        "Obsession-compulsion_short" : "Su",
        "Personality" : "Isiksus",
        "Personality_short" : "I",
        "Safety" : "Ohutus",
        "Safety_short" : "O",
        "Functioning" : "Funktsioneerimine",
        "Functioning_short" : "F",
        "Social activity" : "Sotsiaalne aktiivsus",
        "Social activity_short" : "So",
        "Habits" : "Harjumused",
        "Habits_short" : "H",
        "Sexual activity" : "Seksuaalne aktiivsus",
        "Sexual activity_short" : "Se",

        "I agree" : "Nõustun",
        "Privacy policy" : "Privaatsuspoliitika",
        "Privacy" : "Privaatsus",
        "Cookie policy" : "Küpsisepoliitika",
        "Terms of use" : "Kasutustingimused",
        
        "Internet connection lost. " : "Interneti-ühendus katkes. ",
        "Connection lost with the server. " : "Ühendus serveriga katkes. ",
        "Please reload the web page. " : "Palun laadige veebileht uuesti. ",
        "Please start over. " : "Palun alusta uuesti. ",

        "We are sorry, but currently the project works for those who are located in Ukraine. " : "Vabandame, kuid praegu on see projekt neile, kes asuvad Ukrainas. ",
        "We are sorry, but currently the project works for those who are located in Ukraine and in Estonia. " : "Vabandame, kuid praegu on see projekt neile, kes asuvad Ukrainas või Eestis. "
      
      }
    },
    "ru": {
      "translations": {
        "Estonian" : "Эстонский",
        "English" : "Aнглийский",
        "Russian" : "Pусский",
        "Ukrainian" : "Украинец",

        // Countries in phone number list
        "Poland" : "Польша",
        "Estonia" : "Эстония",
        "Latvia" : "Латвия",
        "Lithuania" : "Литва",
        "Germany" :"Германия",
        "Ukraine" : "Украина",
        "Moldova, Republic of" : "Молдова",
        "Hungary" : "Венгрия",
        "Romania": "Румыния",
        "Slovakia": "Словакия",
        "Belarus" : "Беларусь",
        "Russia" : "Россия",
        
        
        "Rate" : "Подтвердить рейтинг",
        "Yes" : "Да",
        "No" : "Нет",
        "Close": "Закрыть",
        "Clear": "Отменить",
        "Finish" : "Заканчивать",
        "Continue" : "Продолжить",
        "Open": "Открыть",
        "Start": "Начать",
		    "Next" : "Дальше",
		    "Previous" : "Назад",
        "Please wait" : "Пожалуйста, подождите",
        "Problem" : "Ошибка",
        "There was an error with your request. Please try again." : "В вашем запросе произошла ошибка. Пожалуйста, попробуйте еще раз.", // Need translator
        "An technical error occurred, please try again." : "Произошла техническая ошибка, попробуйте еще раз.",// Need translator
        "The calendar is loading" : "Календарь загружается",
        "Loading" : "Загрузка",// Need translator confirm
        "Loading available times" : "Загрузка доступных времен",
        "Pick a date to see available times" : "Выберите дату, чтобы увидеть свободное время",
        "Loading available dates" : "Загрузка доступных дат",
        "No available dates were found in the selected month" : "В выбранном месяце свободных дат не найдено",
        "No available dates found" : "Свободных дат не найдено",
        
        "Insufficient data for evaluation" : "Недостаточно информации для оценки",
        "No deviations detected" : "Отклонения не обнаружены",
        "Moderate deviations" : "Умеренные отклонения",
        "Significant deviations" : "Значительные отклонения",
        "Mental health self-assessment" : "Форма самооценки ментального здоровья",
        "Summary" : "Резюме", // Need translator,
        "Summary of the results" : "Резюме результатов",
        
        "Download the self-assessment summary" : "Скачать сводку самооценки",
        "Download to .pdf" : "Скачать в .pdf",
        "Download as .pdf" : "Скачать как .pdf",
        "Would you like to book a free 30 minutes video consultation?" : "Хотите заказать бесплатную 30-минутную видеоконсультацию?",

        "In our opinion, you do not need a consultation with a mental health professional." : "По нашему мнению, вам не нужна консультация специалиста по душевному здоровью.",
        "We offer the opportunity for a free video consultation. You will find more information after starting the process of booking" : "Предлагаем возможность бесплатной видеоконсультации. Вы найдете больше информации после начала бронирования",
        "We recommend a consultation with a psychiatrist" : "Рекомендуем консультацию специалиста",
        "We recommend a consultation with a psychologist" : "Рекомендуем консультацию специалиста",

        "Book a video-consultation" : "Записаться на видеоконсультацию",
        "Enter video consultation" : "Войти в видеоконсультацию",
        "Book a repeat visit" : "Регистрация на повторный визит",
        "Visit the same doctor" : "Посетите того же врача",

        // Need translator
        "At the moment, there are no planned visits and it's not yet possible to book a new visit either." : "На данный момент запланированных визитов нет и записаться на новый визит пока невозможно.", 
        
        "bookModeDefault" : "Найдите свободное время",
        "bookModeAllDoctors" : "Выберите врача",
        "bookModeRepeatVisit" : "K тому же врачу",
        "bookModeRepeatVisit2" : "Выберите услугу и врача",

        "Any employee" : "Любой сотрудник",
        "All doctors" : "Все врачи",

        "Select time" : "Выберите время",
        "No available times" : "Нет свободного времени",
        "Confirm time" : "Подтвердить время",
        "Name" : "Имя",
        "Confirm booking" : "Подтвердить бронирование",
        "Cancel" : "Отмена",

        "Thank you" : "Спасибо",
        "Answers are saved" : "Ваш ответ записан.",
        "You have completed the questionnaire." : "Вы заполнили анкету.",
        "If you wish, you can book an appointment for a doctor's consultation." : "При желании вы можете записаться на консультацию к врачу.",
        "Your answers have been forwarded to your doctor." : "Ваши ответы были отправлены вашему врачу.",

        "Selected date and time" : "Выбранная дата и время",
        "Service" : "Услуга",
        "Service performer" : "Специалист",
        "Selected date" : "Выбранная дата",
        "Selected time" : "Выбранное время",
        "_DATE_ at _TIME_" : "_DATE_ г _TIME_",
        
        "Skip" : "Пропустить", 
        "Select time for 30 minutes consultation" : "Выберите время для 30-минутной консультации", 
        "I don't want to proceed" : "Я не хочу продолжать",
        "How would you rate your experience with our product" : "Как бы Вы оценили свой опыт использования нашего сервиса?",
        
        "Year" : "Год",
        "Month" : "Месяц",
        "Day" : "День",
        
        "January" : "Январь",
        "February" : "февраль",
        "March" : "Март",
        "April" : "Апрель",
        "May" : "Май",
        "June" : "Июнь",
        "July" : "Июль",
        "August" : "Август",
        "September" : "Сентябрь",
        "October" : "Октябрь",
        "November" : "Ноябрь",
        "December" : "Декабрь",

        "Monday" : "Oнедельник",
        "Tuesday" : "Вторник",
        "Wednesday" : "Среда",
        "Thursday" : "Четверг",
        "Friday" : "Пятница",
        "Saturday" : "Суббота",
        "Sunday" : "Воскресенье",
        
        "National identification number" : "Личный код",
        "Estonian identification number" : "Эстонский личный код",
        "Fill only if you have Estonian national identification number" : "Заполните только в случае, если у вас есть эстонский личный код",
        "First name" : "Имя",
        "Surname" : "Фамилия",
        "Date of birth" : "Дата рождения",
        "Phone (country code)" : "Телефон (код страны)",
        "E-mail" : "Электронная почта",
        "Book an appointment" : "Забронировать время",
        "I agree to the terms of service and data sharing" : "Я согласен с условиями сервиса и обмена данными",
        "Please fill in the field" : "Пожалуйста, заполните поле",
        "Please fill in the required field" : "Пожалуйста, заполните необходимое поле",
        "Please fill in the field correctly" : "Пожалуйста, заполните поле правильно",
        "Confirm" : "Подтвердить", 

        "Book a video-consultation with a psychiatrist" : "Записаться на видеоконсультацию к специалисту",
        "Book a video-consultation with a psychologist" : "Записаться на видеоконсультацию к специалисту",
        
        "Significant mental health deteriorations are identified." : "Выявлены значительные отклонения в душевном здоровье.",
        "Moderate mental health deteriorations are identified." : "Выявлены умеренные отклонения в душевном здоровье.",
        "We recommend a psychiatric consultation." : "Рекомендуем проконсультироваться со специалистом.",
        "I would like to book a 45-minute video consultation." : "Хочу записаться на 45-минутную видео-консультацию.",
        "I would like to book a 30-minute video consultation." : "Хочу записаться на 30-минутную видео-консультацию.",
        "Please enter your personal ID number to start the booking" : "Пожалуйста, введите свой личный код, чтобы начать бронирование",
        "We will direct you to book an appointment." : "Направляем Вас на бронировку времени",
        "I'm booking" : "Бронирую",
        "To book" : "Забронировать",

        "Please note!" : "Обратите внимание!",
        "I have read and agree to the terms and conditions of the service" : "Ознакомился/Ознакомилась и соглашаюсь с условиями сервиса",
        
        "Select service" : "Выберите услугу",
        "Select practicioner" : "Выберите практикующего",

        "Mood" : "Настроение",
        "Mood_short" : "На",
        "Anxiety" : "Тревога",
        "Anxiety_short" : "Тр",
        "Physical health" : "Физическое здоровье",
        "Physical health_short" : "Фи",
        "Sleep" : "Сон",
        "Sleep_short" : "Со",
        "Eating" : "Прием пищи",
        "Eating_short" : "Пр",
        "Cognitive ability" : "Когнитивная способность",
        "Cognitive ability_short" : "Ко",
        "Substance use" : "Употребление психоактивных веществ",
        "Substance use_short" : "У",
        "Unusual experiences" : "Необычные переживания",
        "Unusual experiences_short" : "Не",
        "Stress" : "Стресс",
        "Stress_short" : "Ст",
        "Obsession-compulsion" : "Навязчивое состояние",
        "Obsession-compulsion_short" : "Нав",
        "Personality" : "Личность",
        "Personality_short" : "Ли",
        "Safety" : "Безопасность",
        "Safety_short" : "Б",
        "Functioning" : "Функционирование",
        "Functioning_short" : "Фу",
        "Social activity" : "Социальная активность",
        "Social activity_short" : "Со",
        "Habits" : "Привычки",
        "Habits_short" : "П",
        "Sexual activity" : "Сексуальная активность",
        "Sexual activity_short" : "Се",
        
        "I agree" : "Я согласен",
        "Privacy policy" : "Политика конфиденциальности",
        "Privacy" : "Приватность",
        "Cookie policy" : "Политика в отношении файлов cookie",
        "Terms of use" : "Условия эксплуатации",

        "Internet connection lost. " : "Интернет-соединение потеряно. ",
        "Connection lost with the server. " : "Потеряно соединение с сервером.",
        "Please reload the web page. " : "Пожалуйста, перезагрузите веб-страницу. ",
        "Please start over. " : "Пожалуйста, начните сначала. ",

        "We are sorry, but currently the project works for those who are located in Ukraine. " : "Просим прощения, но сейчас проект работает для тех, кто находится на территории Украины. ",
        "We are sorry, but currently the project works for those who are located in Ukraine and in Estonia. " : "Просим прощения, но сейчас проект работает для тех, кто находится на территории Украины и Эстонии. "
      
      }
    },
    "uk": {
      "translations": {
        "Estonian" : "Eстонська",
        "English" : "Aнглійська",
        "Russian" : "Pосійський",
        "Ukrainian" : "Український",
        
        // Countries in phone number list
        "Poland" : "Польща",
        "Estonia" : "Естонія",
        "Latvia" : "Латвія",
        "Lithuania" : "Литва",
        "Germany" :"Німеччина",
        "Ukraine" : "Україна",
        "Moldova, Republic of" : "Молдова",
        "Hungary" : "Угорщина",
        "Romania": "Румунія",
        "Slovakia": "Словаччина",
        "Belarus" : "Білорусь",
        "Russia" : "Росія",
        
        
        "Rate" : "Підтвердьте рейтинг",
        "Yes" : "Так",
        "No" : "Ні",
        "Close": "Закрити",
        "Clear": "Отменить",
        "Finish" : "Закінчити",
        "Continue" : "Продовжити",
        "Open": "Открытым",
        "Start": "Почати",
		    "Next" : "Далі",
		    "Previous" : "Назад",
        "Please wait" : "Зачекайте",
        "Problem" : "Помилка",
        "There was an error with your request. Please try again." : "З вашим запитом сталася помилка. Будь ласка спробуйте ще раз.", // Need translator
        "An technical error occurred, please try again." : "Сталася технічна помилка, спробуйте ще раз.",// Need translator
        "The calendar is loading" : "Календар завантажується",
        "Loading" : "Завантаження",// Need translator confirm,
        "Loading available times" : "Завантаження доступних часів",
        "Pick a date to see available times" : "Виберіть дату, щоб побачити вільний час",
        "Loading available dates" : "Завантаження доступних дат",
        "No available dates were found in the selected month" : "У вибраному місяці вільних дат не знайдено",
        "No available dates found" : "Bільних дат не знайдено",

        
        "Insufficient data for evaluation" : "Недостатньо інформації для оцінки",
        "No deviations detected" : "Відхилення не виявлені",
        "Moderate deviations" : "Помірні відхилення",
        "Significant deviations" : "Значні відхилення",
        "Mental health self-assessment" : "Форма самооцінки ментального здоров'я",
        "Summary" : "Резюме", // Need translator,
        "Summary of the results" : "Підсумок результатів",
        
        "Download the self-assessment summary" : "Завантажте резюме самооцінювання",
        "Download to .pdf" : "Завантажити в .pdf",
        "Download as .pdf" : "Завантажити як .pdf",
        "Would you like to book a free 30 minutes video consultation?" : "Бажаєте замовити безкоштовну 30-хвилинну відеоконсультацію?",
        
        "In our opinion, you do not need a consultation with a mental health professional." : "На нашу думку, вам не потрібна консультація спеціаліста із душевного здоров'я",
        "We offer the opportunity for a free video consultation. You will find more information after starting the process of booking" : "Пропонуємо можливість безкоштовної відеоконсультації. Ви знайдете більше інформації після початку бронювання",
        "We recommend a consultation with a psychiatrist" : "Рекомендуємо консультацію спеціаліста",
        "We recommend a consultation with a psychologist" : "Рекомендуємо консультацію Спеціаліста",

        "Book a video-consultation" : "Записатися на відеоконсультацію",
        "Enter video consultation" : "Увійти у відеоконсультацію",
        "Book a repeat visit" : "Реєстрація на повторний візит",
        "Visit the same doctor" : "Відвідайте того ж лікаря",

        // Need translator
        "At the moment, there are no planned visits and it's not yet possible to book a new visit either." : "На даний момент немає запланованих візитів і поки що неможливо записатися на новий візит.", 
        
        "bookModeDefault" : "Оберіть вільний час",
        "bookModeAllDoctors" : "Оберіть лікаря",
        "bookModeRepeatVisit" : "Той же лікар",
        "bookModeRepeatVisit2" : "Оберіть послугу та лікаря",

        "Any employee" : "Будь-який працівник",
        "All doctors" : "Всі лікарі",

        "Select time" : "Вибрати час",
        "No available times" : "Немає доступного часу",
        "Confirm time" : "Підтвердити час",
        "Name" : "Ім'я",
        "Confirm booking" : "Підтвердити бронювання",
        "Cancel" : "Скасувати",

        "Thank you" : "Дякуємо",
        "Answers are saved" : "Відповіді збережено",
        "You have completed the questionnaire." : "Ви заповнили анкету.",
        "If you wish, you can book an appointment for a doctor's consultation." : "При бажанні Ви можете записатися на консультацію до лікаря.",
        "Your answers have been forwarded to your doctor." : "Ваші відповіді було передано вашому лікарю.",

        "Selected date and time" : "Вибрана дата і час",
        "Service" : "Послуга",
        "Service performer" : "Спеціаліст",
        "Selected date" : "Вибрана дата",
        "Selected time" : "Oбраний час",
        "_DATE_ at _TIME_" : "_DATE_ року о _TIME_",
        
        
        "Skip" : "Пропустити", 
        "Select time for 30 minutes consultation" : "Виберіть час для 30-хвилинної консультації", 
        "I don't want to proceed" : "Я не хочу продовжувати",
        "How would you rate your experience with our product" : "Як Ви оцінили б свій досвід роботи з нашим продуктом",
        
        "Year" : "Рік",
        "Month" : "Місяць",
        "Day" : "День",
        
        "January" : "Січень",      // с С
        "February" : "Лютий",      // л Л
        "March" : "березень",      // б Б 
        "April" : "Квітень",       // к К
        "May" : "Травень",         // т Т
        "June" : "Червень",        // ч Ч 
        "July" : "Липень",         //  л Л
        "August" : "Серпень",
        "September" : "Вересень",  // в  В
        "October" : "Жовтень",     // ж Ж
        "November" : "Листопад",
        "December" : "Грудень",    // г  Г

        "Monday" : "понеділок",
        "Tuesday" : "Вівторок",
        "Wednesday" : "Середа",
        "Thursday" : "Четвер",
        "Friday" : "П'ятниця",
        "Saturday" : "Субота",
        "Sunday" : "неділя",
        
        "National identification number" : "Персональний код",
        "Estonian identification number" : "Естонський персональний код",
        "Fill only if you have Estonian national identification number" : "Заповнюйте лише, якщо у вас є естонський національний ідентифікаційний номер",
        "First name" : "Ім'я",
        "Surname" : "Прізвище",
        "Date of birth" : "Дата народження",
        "Phone (country code)" : "Телефон (код країни)",
        "E-mail" : "Електронна пошта",
        "Book an appointment" : "Записатися",
        "I agree to the terms of service and data sharing" : "Я згоден з умовами сервісу та обміну даними",
        "Please fill in the field" : "Будь ласка, заповніть поле",
        "Please fill in the required field" : "Будь ласка, заповніть обов'язкове поле",
        "Please fill in the field correctly" : "Будь ласка, заповніть поле правильно",
        "Confirm" : "Підтвердити", 

        "Book a video-consultation with a psychiatrist" : "Записатися на відеоконсультацію до cпеціаліста",
        "Book a video-consultation with a psychologist" : "Записатися на відеоконсультацію до cпеціаліста",
        
        "Significant mental health deteriorations are identified." : "Significant mental health deteriorations are identified.",
        "Moderate mental health deteriorations are identified." : "Moderate mental health deteriorations are identified.",
        "We recommend a psychiatric consultation." : "We recommend a psychiatric consultation.",
        "I would like to book a 45-minute video consultation." : "I would like to book a 45-minute video consultation.",
        "I would like to book a 30-minute video consultation." : "I would like to book a 30-minute video consultation.",
        "Please enter your personal ID number to start the booking" : "Please enter your personal ID number to start the booking",
        "We will direct you to book an appointment." : "We will direct you to book an appointment",
        "I'm booking" : "I'm booking",
        "To book" : "To book",

        "Please note!" : "Зверніть увагу!",
        "I have read and agree to the terms and conditions of the service" : "Ознайомився/Ознайомилася і погоджуюся з умовами сервісу",
        
        "Select service" : "Виберіть послугу",
        "Select practicioner" : "Оберіть спецiалiста",

        "Mood" : "Настрій",
        "Mood_short" : "Нa",
        "Anxiety" : "Тривога",
        "Anxiety_short" : "",
        "Physical health" : "Фізичне здоров'я",
        "Physical health_short" : "Фі",
        "Sleep" : "Сон",
        "Sleep_short" : "Сон",
        "Eating" : "Споживання їжі",
        "Eating_short" : "Сп",
        "Cognitive ability" : "Когнітивна здатність",
        "Cognitive ability_short" : "К",
        "Substance use" : "Вживання психоактивних речовин",
        "Substance use_short" : "В",
        "Unusual experiences" : "Незвичайні переживання",
        "Unusual experiences_short" : "Не",
        "Stress" : "Стрес",
        "Stress_short" : "Ст",
        "Obsession-compulsion" : "Нав'язливий стан",
        "Obsession-compulsion_short" : "Нав",
        "Personality" : "Особистість",
        "Personality_short" : "О",
        "Safety" : "Безпека",
        "Safety_short" : "Б",
        "Functioning" : "Функціонування",
        "Functioning_short" : "Фу",
        "Social activity" : "Соціальна активність",
        "Social activity_short" : "Со",
        "Habits" : "Звички",
        "Habits_short" : "З",
        "Sexual activity" : "Сексуальна активність",
        "Sexual activity_short" : "Се",
        
        "I agree" : "Я згоден",
        "Privacy policy" : "Політика конфіденційності",
        "Privacy" : "Приватність",
        "Cookie policy" : "Політика щодо файлів cookie",
        "Terms of use" : "Умови користування",
        
        "Internet connection lost. " : "Інтернет-з’єднання втрачено. ",
        "Connection lost with the server. " : "З'єднання з сервером втрачено. ",
        "Please reload the web page. " : "Перезавантажте веб-сторінку. ",
        "Please start over. " : "Будь ласка, почніть спочатку. ",

        "We are sorry, but currently the project works for those who are located in Ukraine. " :                "Просимо вибачення, але зараз проєкт працює для тих, хто знаходиться на території України. ",
        "We are sorry, but currently the project works for those who are located in Ukraine and in Estonia. " : "Просимо вибачення, але зараз проєкт працює для тих, хто знаходиться на території України та Естонії. "
      
      }
    }
  },
  "fallbackLng": "en",
  "lng": "et",
  "debug": false,

  // have a common namespace used around the full app
  "ns": ["translations"],
  "defaultNS": "translations",

  "keySeparator": false, // we use content as keys

  "interpolation": {
    "escapeValue": false, // not needed for react!!
    "formatSeparator": ","
  },

  "react": {
    "wait": true
  }
}


// use external translations if defined
/*global externalAppTranslations */
if( typeof externalAppTranslations != 'undefined' ){
  
  if( typeof externalAppTranslations.et != 'undefined' ){
    i18nConfiguration.resources.et.translations = Object.assign( i18nConfiguration.resources.et.translations, externalAppTranslations.et.translations );
    console.log( 'App et translations were overwritten with external language file' );
  }
  if( typeof externalAppTranslations.en != 'undefined' ){
    i18nConfiguration.resources.en.translations = Object.assign( i18nConfiguration.resources.en.translations, externalAppTranslations.en.translations );
    console.log( 'App en translations were overwritten with external language file' );
  }
  if( typeof externalAppTranslations.ru != 'undefined' ){
    i18nConfiguration.resources.ru.translations = Object.assign( i18nConfiguration.resources.ru.translations, externalAppTranslations.ru.translations );
    console.log( 'App ru translations were overwritten with external language file' );
  }
  if( typeof externalAppTranslations.uk != 'undefined' ){
    i18nConfiguration.resources.uk.translations = Object.assign( i18nConfiguration.resources.uk.translations, externalAppTranslations.uk.translations );
    console.log( 'App ua translations were overwritten with external language file' );
  }
}


i18n.use(initReactI18next).init( i18nConfiguration );

export default i18n;
